module.exports = __webpack_public_path__ + "img/couples-033.2cf69413.jpg";